import { Box } from '@freighthub/silhouette-core'
import { get } from 'lodash-es'
import { FC } from 'react'

import { PDAD_CGOMD, PDAD_CGOMO } from '../domain/PdadTypes'
import { TRANSPORT_TYPE_LCL } from '../domain/TransportType'
import {
  getContainersTpGroups,
  getContainersTpSortedByActual,
  getPdadStructure,
  IContainerTP,
} from '../service/TPContainersPlans'
import { TpTrackStep } from './TpTrackStep'
import { PdadWrapper } from './TpTrackStepConnector'

interface TPTrackBarProps {
  containersTp: IContainerTP[]
}

const isTransportModeRailOrBarge = (transportMode: string): boolean =>
  transportMode === 'rail' || transportMode === 'barge'

export const TPTrackBar: FC<TPTrackBarProps> = ({ containersTp }) => {
  const sortedByActual = getContainersTpSortedByActual(containersTp)
  const groupsByActual: IContainerTP[] = getContainersTpGroups(sortedByActual)

  const mostActualContainerTp = sortedByActual[0]
  const showTrackableTitle = mostActualContainerTp.transportType !== TRANSPORT_TYPE_LCL
  const pdadStructure = getPdadStructure(mostActualContainerTp)

  // CGOMO is only displayed for a subset of shipments, see FH-8725.
  // These include shipments with pre carriage transport mode rail and barge.
  const anyContainerSupportsCgomo = containersTp.some((containerTp) =>
    isTransportModeRailOrBarge(get(containerTp, 'pre.route.transportMode'))
  )

  // CGOMD is only displayed for a subset of shipments, see FH-8629.
  // These include shipments with on carriage transport mode rail and barge.
  const anyContainerSupportsCgomd = containersTp.some((containerTp) =>
    isTransportModeRailOrBarge(get(containerTp, 'on.route.transportMode'))
  )

  const widthPercentage = 100 / mostActualContainerTp.pdadSequence.length
  const pdadItemsToShow = mostActualContainerTp.pdadSequence.filter((pdadItem) => {
    const isItemCgomo = pdadItem.pdadType === PDAD_CGOMO
    const isItemCgomd = pdadItem.pdadType === PDAD_CGOMD
    const isItemNotCg = !isItemCgomo && !isItemCgomd

    const showCgomo = isItemCgomo && anyContainerSupportsCgomo
    const showCgomd = isItemCgomd && anyContainerSupportsCgomd

    return isItemNotCg || showCgomo || showCgomd
  })

  return (
    <Box display="flex" pt={13.75} pb={2}>
      {pdadItemsToShow.map((pdadItem, pdadIndex) => {
        const pdadWrappers: PdadWrapper[] = groupsByActual.map((p) => ({
          trackableVisualInfo: p,
          pdad: pdadItemsToShow[pdadIndex],
          isNextProgress: pdadItemsToShow[pdadIndex + 1] && pdadItemsToShow[pdadIndex + 1].isProgress,
        }))

        return (
          <TpTrackStep
            showTrackableTitle={showTrackableTitle}
            key={pdadIndex}
            pdadWrappers={pdadWrappers}
            // @ts-expect-error TS(2322) FIXME: Type '(IShipTpEvent | undefined)[]' is not assigna... Remove this comment to see the full error message
            events={containersTp.map((ctp) => ctp.pdadEvents[pdadItem.pdadType])}
            pdadItem={pdadItem}
            prev={pdadItemsToShow[pdadIndex - 1]}
            pdadStructure={pdadStructure}
            widthPercentage={widthPercentage}
          />
        )
      })}
    </Box>
  )
}
